/**
 * code originally from:
 *      http://stackoverflow.com/questions/34489916/load-external-js-script-dynamically-in-angular-2
 * maintained by lingyb
 */
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/concat';
import 'rxjs/add/observable/empty';

export interface Scripts {
    name: string;
    src?: string;
}

export const ScriptStore: Scripts[] = [{
    name: 'jquery',
    src: 'https://o8ci6tgz8.qnssl.com/assets/libs/jquery.min.js'
}, { name: 'aaa'}, { name: 'bbb'}, { name: 'ccc'}]; // 这里放一些初始化的库

declare var document: any;

@Injectable()
export class ScriptService {

    private scripts: any = {};
    // private scriptsAdded: any = {};
    private observer: Observable<any>;

    constructor() {
        this.initScriptData();
    }

    public setScripts(scripts: Scripts[]) {
        scripts.forEach((script) => ScriptStore.push(script));
        this.initScriptData();
    }

    public addScript(script: Scripts) {
        ScriptStore.push(script);
        this.scripts[script.name] = {
            loaded: false,
            src: script.src
        };
    }

    public load(...scripts: any[]) {
        let observers: Array<Observable<any> > = [];
        this.observer = Observable.of({status: 'init'});

        scripts.forEach((item) => {
            if (!item) {
                return;
            }
            if (typeof item === 'string') {
                const name = item;
                const newObs = this.loadScript(name);
                observers.push(newObs);
                this.merge(newObs);
            } else if (item.length > 0) {
                item.forEach((name, index) => {
                    const tmpObs = index ? observers[observers.length - 1] : null;
                    const newObs = this.loadScript(name, tmpObs);
                    observers.push(newObs);
                    this.concat(newObs);
                });
            }
        });
        this.observer.subscribe((d) => {
            // this.scriptLoaded(d);
            // console.log('[subscribe]', d);
        });
        return Observable.combineLatest(observers);
    }
    private merge(newObs) {
        this.observer = this.observer.merge(newObs);
    }
    private concat(newObs) {
        this.observer = this.observer.concat(newObs);
    }

    private loadScript(
            name: string,
            lastObserver?: Observable<any> // 当concat的时候必须带上
            ): Observable<any> {
        const script = this.scripts[name];
        if (script) {
            if (script.loaded) {
                return Observable.of({script: name, loaded: true});
            } else {
                // to load scripts
                const scriptDom = document.createElement('script');
                scriptDom.type = 'text/javascript';
                scriptDom.src = script.src;
                // console.log('parsing script...', name);
                const result = {
                    name,
                    status: 'loaded',
                };
                const observer = Observable.fromEvent(scriptDom, 'load')
                    .map((d) => {
                        return result;
                    });
                observer.subscribe((d) => {
                    this.scriptLoaded(d);
                });
                if (lastObserver) {
                    lastObserver.subscribe((data) => {
                        // console.log('[do]', name);
                        this.appendToBody(scriptDom);
                        // this.scriptLoaded(data);
                    });
                } else {
                    this.appendToBody(scriptDom);
                }
                return observer;
            }
        } else {
            return Observable.empty();
        }
    }
    private appendToBody(dom) {
        // console.log('[append] dom', dom.src);
        document.getElementsByTagName('head')[0]
            .appendChild(dom);
    }

    private scriptLoaded(data) {
        if (data.status === 'init') {
            return;
        }
        // console.log(++this.loadedCnt, observers.length);
        const script = this.scripts[data.name];
        if (script) {
            script.loaded = true;
            console.log('[loaded]', data);
        }
    }
    private initScriptData() {
        ScriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }

}
